module.exports = __webpack_public_path__ + "img/rec-04.3d20c510.png";